// removed by extract-text-webpack-plugin
module.exports = {"documents":"_29aU0smjXbdwsqGzfjUZJz","readmore":"_23lUjWLdu54kx36q2Qpq3Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentListBlock/DocumentListBlock.module.scss
// module id = 752
// module chunks = 0